// extracted by mini-css-extract-plugin
module.exports = {"root":"PageRow_root__rzll1","rowTitle":"PageRow_rowTitle__ikGMc"};